import { StructuredData } from './StructuredData';
import { FOUNDERS, ORGANIZATION } from '@/seo/organization';

const founders = FOUNDERS.map(person => ({ '@context': 'https://schema.org', ...person }));

export function AboutStructuredData() {
  return <StructuredData data={[ORGANIZATION, ...founders]} />;
}
